import React from "react";
import SkeletonTable from "../../Common/SkeletonTable";
import ErrorCard from "../../Common/ErrorCard";
import EmptyCard from "../../Common/EmptyCard";
import { getInventoryTypeTitle } from "../../../../../utilities/helpers";
import { DEFAULT_PAGE_SIZE } from "../../../utils/inventoryHelper";

const WarehouseTransferTable = ({
  page,
  transferData,
  loading,
  error,
  searchTerm,
}) => {
  const formatDestinationType = (type) => {
    return type === "agency" ? "Distribution House" : "Warehouse";
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    } catch {
      return dateString;
    }
  };

  const formatElapsedTime = (days) => {
    if (!days && days !== 0) return "";
    if (days === 0) return "Today";
    if (days === 1) return "1 day";
    return `${days} days`;
  };

  const renderTableContent = () => {
    if (loading) {
      return (
        <SkeletonTable
          columnCount={9}
          rowCount={7}
          headers={[
            "#",
            "Transfer ID",
            "Destination Type",
            "Destination",
            "Inventory Type",
            "Total Inventory",
            "Received",
            "Transfer Date",
            "Time Elapsed",
          ]}
        />
      );
    }

    if (error) {
      return (
        <ErrorCard
          title="Error loading transfer data"
          message="Failed to load transfer data. Please try again."
        />
      );
    }

    if (transferData.length === 0) {
      return (
        <EmptyCard
          title="No transfer data found"
          message={
            searchTerm
              ? "No transfer data found matching your search criteria."
              : "No transfer data available for this warehouse."
          }
        />
      );
    }

    return (
      <table className="inventory-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Transfer ID</th>
            <th>Destination Type</th>
            <th>Destination</th>
            <th>Inventory Type</th>
            <th>Total Inventory</th>
            <th>Received</th>
            <th>Transfer Date</th>
            <th>Time Elapsed</th>
          </tr>
        </thead>
        <tbody>
          {transferData.map((transfer, index) => (
            <tr key={index + 1} className="table-row">
              <td>{(page - 1) * DEFAULT_PAGE_SIZE + index + 1}</td>
              <td>{transfer.unique_id}</td>
              <td>{formatDestinationType(transfer.destination_type)}</td>
              <td title={transfer.destination_name || ""}>
                {transfer.destination_name}
              </td>
              <td>{getInventoryTypeTitle(transfer.model_type) || ""}</td>
              <td>{transfer.total_devices?.toLocaleString() || 0}</td>
              <td>{transfer.received_devices || 0}</td>
              <td>{formatDate(transfer.transfer_date)}</td>
              <td>{formatElapsedTime(transfer.elapsed_days)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  return renderTableContent();
};

export default WarehouseTransferTable;
